module.exports = {"data":{"site":{"siteMetadata":{"title":"Gatsby + Netlify CMS Starter"}},"allMarkdownRemark":{"totalCount":1,"edges":[{"node":{"fields":{"slug":"/blog/2017-01-04-a-beginners-guide-to-brewing-with-chemex/"},"frontmatter":{"title":"A beginners’ guide to brewing with Chemex"}}}]}},"pathContext":{"tag":"chemex"}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/tags-chemex.json
// module id = 360
// module chunks = 86274549634625